/**
 * AnalyticsPageView — first-party beacon route-change hook.
 *
 * Feb 2026 Analytics Commit A. Mounts alongside <MetaPixelPageView />
 * and <RouteViewSync /> in App.js. Fires `page.view` on initial
 * mount and on every subsequent route change, EXCEPT when the
 * route is admin-scoped (`/admin/*`) OR the caller is inside an
 * impersonation session (`user.is_impersonating === true`).
 *
 * Renders nothing — pure side-effect component. The exclusion
 * rules mirror `MetaPixelPageView.jsx` because the same policy
 * ("analytics must not measure ops surfaces or leak impersonated
 * routes") applies to both trackers.
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { trackPageView } from "@/lib/analytics";

export default function AnalyticsPageView() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const isImpersonating = !!user?.is_impersonating;

  useEffect(() => {
    trackPageView({ pathname, isImpersonating });
  }, [pathname, isImpersonating]);

  return null;
}
